/** @flow */

import type { RepeatTimeLostPatternRequest } from "@modules/recording/reducer";
import type { SimplifiedShiftPattern } from "@modules/shared/reducer/employee-absences/types";

export const getRepeatAbsenceShiftPattern = (payload: RepeatTimeLostPatternRequest) => {
  const { daysN, shiftPattern } = payload;
  const daysToRepeat = shiftPattern.slice(0, daysN);
  const daysToRepeatLength = daysToRepeat.length;

  const newShiftPattern = shiftPattern.map((day: SimplifiedShiftPattern, idx: number) => {
    const n = idx >= daysToRepeatLength ? idx % daysN : idx;
    const { dayType, employeePosition, workingTimeInSeconds } = daysToRepeat[n];
    const timeLostInSeconds =
      idx === shiftPattern.length - 1
        ? shiftPattern[idx].timeLostInSeconds
        : daysToRepeat[n].timeLostInSeconds;
    const dataToReplace = {
      dayType,
      employeePosition,
      workingTimeInSeconds,
      timeLostInSeconds,
    };

    return {
      ...day,
      ...dataToReplace,
    };
  });

  return newShiftPattern;
};
